/**
 * kitFormat.ts — the Recovery Kit's shape, mirrored from the server's
 * src/api/recovery/kit.ts.
 *
 * Deliberately duplicated rather than imported: the member app is a separate
 * package with its own tsconfig, and reaching across that boundary for four
 * constants would couple the browser bundle to the server build. The two are
 * held together by kitFormat.test.ts, which reads the server file and asserts
 * they still agree — a silent divergence here would strand every kit already
 * printed and put in a drawer.
 */
export const KIT_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export const KIT_GROUPS = 6;
export const KIT_GROUP_LENGTH = 4;
export const KIT_LENGTH = KIT_GROUPS * KIT_GROUP_LENGTH;
export const KIT_PBKDF2_ITERATIONS = 600_000;

export function formatKit(raw: string): string {
  const groups: string[] = [];
  for (let i = 0; i < raw.length; i += KIT_GROUP_LENGTH) {
    groups.push(raw.slice(i, i + KIT_GROUP_LENGTH));
  }
  return groups.join('-');
}

/**
 * Accepts what a person actually types: lower case, missing dashes, spaces,
 * and the four letters the alphabet leaves out mapped to what they were
 * almost certainly meant to be. Someone reading their own handwriting from
 * years ago should not be defeated by a hyphen.
 */
export function normalizeKit(input: string): string {
  return input
    .toUpperCase()
    .replace(/[\s-]/g, '')
    .replace(/[IL]/g, '1')
    .replace(/O/g, '0')
    .replace(/U/g, 'V');
}

export function isWellFormedKit(input: string): boolean {
  const n = normalizeKit(input);
  return n.length === KIT_LENGTH && [...n].every((c) => KIT_ALPHABET.includes(c));
}

export function kitHint(normalized: string): string {
  return normalized.slice(-KIT_GROUP_LENGTH);
}
